import { render, staticRenderFns } from "./topbanner.vue?vue&type=template&id=136756a9&scoped=true&"
import script from "./topbanner.vue?vue&type=script&lang=js&"
export * from "./topbanner.vue?vue&type=script&lang=js&"
import style0 from "./topbanner.vue?vue&type=style&index=0&id=136756a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136756a9",
  null
  
)

export default component.exports